(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-color"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
 const button=event.target.closest('.sy-swatches button');
 if(!button) return;
 const section=button.closest('.sy-colors');
 for(const item of section.querySelectorAll('button[data-panel]')){
  const active=item===button;
  item.setAttribute('aria-pressed',String(active));
  document.getElementById(item.dataset.panel).hidden=!active;
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
 const button=event.target.closest('[data-look-step]');
 if(!button)return;
 const track=button.closest('.sy-looks').querySelector('.sy-looks__track');
 const card=track.querySelector('.sy-looks__card');
 if(card)track.scrollBy({left:Number(button.dataset.lookStep)*(card.offsetWidth+18),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
});
document.addEventListener('pointerover',event=>{
 const card=event.target.closest('.sy-looks__card');
 if(!card)return;
 card.parentElement.querySelectorAll('.sy-looks__card').forEach(item=>item.classList.toggle('is-active',item===card));
});
document.addEventListener('focusin',event=>{
 const card=event.target.closest('.sy-looks__card');
 if(card)card.parentElement.querySelectorAll('.sy-looks__card').forEach(item=>item.classList.toggle('is-active',item===card));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-nav"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('pointerover',e=>{const d=e.target.closest('.sy-nav details');if(d && e.pointerType==='mouse' && !d.contains(e.relatedTarget))d.open=true});
document.addEventListener('pointerout',e=>{const n=e.target.closest('.sy-nav');if(n && !n.contains(e.relatedTarget) && e.pointerType==='mouse')n.querySelectorAll('details[open]').forEach(d=>d.open=false)});
document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.sy-nav details[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus()})});

  } catch(e) { console.error(e); }
})();
})();
